import { AppButton } from '@/ui/buttons';
import { FlexContainer } from '@/ui/styled-ui';
import { resolveTextDirection } from '@/utils/helpers/language.helper';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledDialog = styled(Dialog)`
  width: 600px;
`;

type SubdomainAssignmentConfirmDialogProps = {
  subdomain?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
};

export const SubdomainAssignmentConfirmDialog: React.FC<
  SubdomainAssignmentConfirmDialogProps
> = ({ subdomain, onConfirm, onCancel }) => {
  const { t, i18n } = useTranslation();
  const resolvedDir = resolveTextDirection(i18n.language);

  if (!subdomain) {
    return null;
  }

  return (
    <StyledDialog
      pt={{ root: { dir: resolvedDir } }}
      blockScroll
      visible
      header={t('account.subdomain.assign.warn.heading')}
      draggable={false}
      data-testid="subdomain-assignment-confirm-modal"
      onHide={onCancel}
    >
      <p>{t('account.subdomain.assign.warn.text', { subdomain })}</p>
      <FlexContainer justify="flex-end" className="mt-5">
        <>
          <AppButton
            label={t('button.cancel')}
            type="outlined"
            className="mr-3"
            onClick={onCancel}
          />
          <AppButton
            label={t('account.subdomain.assign.warn.confirm')}
            onClick={onConfirm}
          />
        </>
      </FlexContainer>
    </StyledDialog>
  );
};
